export async function getCsrf(): Promise<string | null> {
  const response = await fetch('/api/auth/csrf', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: '{}'
  });
  if (!response.ok) return null;
  const { csrf } = await response.json() as { csrf: string };
  sessionStorage.setItem('csrf', csrf);
  return csrf;
}
